export default __webpack_public_path__ + "static/media/left-chevron-green.216804d3.svg";